var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"pa-4",attrs:{"outlined":""}},[_c('h3',[_vm._v("Especificações de produção")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.specifications)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }